import { useState, useEffect } from 'react';

type BizChartsModule = typeof import('bizcharts');
import type { registerShape, registerInteraction } from 'bizcharts';

export type { Axis, Chart, Geom, Interaction, Tooltip } from 'bizcharts';
export type IRegisterShapeOptions = Parameters<typeof registerShape>;
export type Shape = ReturnType<typeof registerShape>;
export type IRegisterInteractionOptions = Parameters<typeof registerInteraction>;

interface IRegisters {
    registerShape?: IRegisterShapeOptions;
    registerInteraction?: IRegisterInteractionOptions;
}

export const useBizcharts = (registers?: IRegisters): BizChartsModule | null => {
    const [bizChartsModules, setBizChartsModules] = useState<BizChartsModule | null>(null);

    useEffect(() => {
        import(/* webpackChunkName: "bizcharts" */ 'bizcharts')
            .then((module: BizChartsModule) => {
                if (registers?.registerShape) {
                    module.registerShape(...registers.registerShape);
                }
                if (registers?.registerInteraction) {
                    module.registerInteraction(...registers.registerInteraction);
                }
                setBizChartsModules(module);
            })
            .catch((error) => {
                console.error('load bizcharts failed:', error);
            });
    }, []);

    return bizChartsModules;
};
